import { render, staticRenderFns } from "./Pensions.vue?vue&type=template&id=bb6efeea"
import script from "./Pensions.vue?vue&type=script&lang=js"
export * from "./Pensions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports